const getters = {
  userInfo: state => state.app.userInfo,
  isMobile: state => state.app.isMobile,
  publishStatus: state => state.app.publishStatus
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js